<template>
    <div id="data-parametro-meta-view">
        <vx-card class="mb-base" no-shadow card-border>           

            <div class="justify-between flex-grow vx-row">

                <div class="mt-2 vx-col mb-sm-0">
                    <feather-icon icon="ActivityIcon" class="mr-2" svgClasses="w-5 h-5" />
                    <span class="font-medium leading-none">Registro de Metas</span>
                </div>

                <div class="flex-wrap justify-end w-full d-flex vx-col md:w-1/6">
                    <v-select :options="itemsAnioEjec" v-model="selectedAnioEjec" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" name="anioEjec">
                        <template v-slot:no-options="{ searching }">
                            <template v-if="searching">
                                No se encontraron resultados
                            </template>
                            <span v-else style="opacity: 0.5">No existen resultados</span>
                        </template>
                    </v-select>
                </div>

            </div>

            <vs-divider/>

            <div class="justify-between flex-grow vx-row">
                <div class="w-full mb-2 vx-col md:w-1/5">                   
                    <div class="mb-2">
                        <label class="text-sm opacity-75">Estado</label>
                        <v-select :options="itemsEstado" v-model="selectedEstado" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" name="estado">
                            <template v-slot:no-options="{ searching }">
                                <template v-if="searching">
                                    No se encontraron resultados
                                </template>
                                <span v-else style="opacity: 0.5">No existen resultados</span>
                            </template>
                        </v-select>
                        <span class="text-sm text-danger" v-show="errors.has('estado')">{{ errors.first('estado') }}</span>
                    </div>
                </div>

                <div class="flex flex-wrap-reverse items-center justify-end flex-grow">
                    <div class="flex flex-wrap items-center justify-start mr-4">
                        <vs-button @click="sincronizar" icon-pack="feather" color="primary" icon="icon-refresh-cw" class="ml-auto vs-con-loading__container" id="button-sincr-with-loading">Actualizar</vs-button>
                    </div>
                </div>

            </div>

            <vs-table stripe ref="table" :data="itemsMeta" pagination :max-items="itemsPerPage" search noDataText="No existen datos">
                <div slot="header" class="flex flex-wrap-reverse items-center justify-between flex-grow">
                    <vs-dropdown vs-trigger-click class="mb-4 mr-4 cursor-pointer items-per-page-handler">
                        <div class="flex items-center justify-between p-4 font-medium border border-solid rounded-full cursor-pointer d-theme-border-grey-light d-theme-dark-bg">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ itemsMeta.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : itemsMeta.length }} de {{ itemsMeta.length }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="itemsPerPage=5">
                            <span>5</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=10">
                            <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=25">
                            <span>25</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                            <span>50</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th class="">META</vs-th>
                    <vs-th class="">CUI/COD. SNIP</vs-th>
                    <vs-th class="">FINALIDAD</vs-th>
                    <vs-th class="">FUNCION</vs-th>
                    <vs-th class="">UNIDAD EJEC.</vs-th>
                    <vs-th class="">AÑO</vs-th>
                    <vs-th class="">ESTADO</vs-th>
                    <vs-th class="">ACCIONES</vs-th>
                </template>

                <template slot-scope="{data}">
                    <tbody>
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].meta">
                                <strong>
                                    <span class="text-primary text-bold">{{data[indextr].meta}}</span>
                                </strong>
                            </vs-td>
                            <vs-td :data="data[indextr].codigoProductoProyecto">
                                <strong>
                                    <span class="text-warning text-bold">{{data[indextr].codigoProductoProyecto}}</span>
                                </strong>
                            </vs-td>
                            <vs-td :data="data[indextr].productoProyecto">
                                {{ data[indextr].productoProyecto }}
                            </vs-td>
                            <vs-td :data="data[indextr].funcion">
                                {{ data[indextr].funcion }}
                            </vs-td>
                            <vs-td :data="data[indextr].uejec">
                                <strong>
                                    <span class="text-info text-bold">{{data[indextr].uejec}}</span>
                                </strong>
                            </vs-td>
                            <vs-td :data="data[indextr].anio">
                                {{ data[indextr].anio }}
                            </vs-td>
                            <vs-td :data="data[indextr].enable">
                                <vs-chip transparent :color="getOrderStatusColor(data[indextr].estado)">
                                    <span class="font-medium truncate"> {{ data[indextr].estado ? 'Habilitado' : 'Inhabilitado' }}</span>
                                </vs-chip>
                            </vs-td>
                            <vs-td :data="data[indextr].meta" class="whitespace-no-wrap">
                                <div class="vx-row-actions">
                                    <vx-tooltip v-if="!data[indextr].estado" text="Habilitar meta" position="bottom">
                                        <vs-button v-if="!data[indextr].estado" @click="enabled(tr)" class="ml-2" color="success" type="filled" icon-pack="feather" icon="icon-thumbs-up" size="small"></vs-button>
                                    </vx-tooltip>
                                    <vx-tooltip v-if="data[indextr].estado" text="Inhabilitar meta" position="bottom">
                                        <vs-button v-if="data[indextr].estado" @click="disabled(tr)" color="danger" type="filled" icon-pack="feather" icon="icon-thumbs-down" size="small"></vs-button>
                                    </vx-tooltip>
                                    <vx-tooltip text="Editar meta" position="bottom">
                                        <vs-button @click="edit(tr)" class="ml-2" color="rgb(62, 201, 214)" type="filled" icon-pack="feather" icon="icon-edit" size="small"></vs-button>
                                    </vx-tooltip>
                                </div>
                            </vs-td>
                        </vs-tr>
                    </tbody>
                </template>

            </vs-table>

            <div class="flex flex-wrap-reverse items-center justify-end flex-grow">
                <p class="text-sm truncate">
                    Mostrando registros del <strong>{{ currentPage * itemsPerPage - (itemsPerPage - 1) }}</strong> al <strong>{{ itemsMeta.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : itemsMeta.length }}</strong> de un total de <strong>{{ itemsMeta.length }}</strong> registros
                </p>
            </div>
        </vx-card>
    </div>
</template>
<script>
import vSelect from 'vue-select';
export default {
    components: {
        'v-select': vSelect
    },
    data(){
        return {
            itemsMeta: [],
            itemsPerPage: 10,
            isMounted: false,

            metaId: null,
            numeroMeta: null,
            selectedEstado: {value: 0, label: 'Todo'},
            itemsEstado: [{value: 0, label: 'Todo'}, {value: 1, label: 'Habilitado'}, {value: 2, label: 'Inhabilitado'}],

            selectedAnioEjec: {},
            itemsAnioEjec: [],

            backgroundLoading: 'primary',
            colorLoading: '#fff',
        }
    },

    computed: {
        currentPage () {
            if (this.isMounted) {
                return this.$refs.table.currentx;
            }
            return 0;
        },
    },

    mounted () {
        this.isMounted = true;
        this.findAllAnios();
        if(this.selectedAnioEjec.value !== undefined){
            this.fetchMetas(this.selectedAnioEjec.value);
        }
    },

    watch: {
        selectedEstado(seleted){
            if(seleted.value === 0){
                this.getMetasAll();
            } else if(seleted.value == 1){
                this.getMetasEnabled();
            } else {
                this.getMetasDisabled();
            }
        },

        selectedAnioEjec(){
            this.selectedEstado = {value: 0, label: 'Todo'};
            this.getMetasAll();
        }
    },

    methods: {
        findAllAnios(){
            this.$vs.loading();
            this.$http.findAllAniosEjecucion()
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.selectedAnioEjec = {value: response.data[0].value, label: response.data[0].label};
                    this.itemsAnioEjec = response.data;
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },
        
        fetchMetas(value){
            if(value === 0){
                this.getMetasAll();
            } else if(value == 1){
                this.getMetasEnabled();
            } else {
                this.getMetasDisabled();
            }
        },

        getMetasAll(){
            const anio = this.selectedAnioEjec.value;
            this.$vs.loading();
            this.$http.findAllMetas(anio)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsMeta = response.data;
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        getMetasEnabled(){
            const anio = this.selectedAnioEjec.value;
            this.$vs.loading();
            this.$http.listarMetasHabilitados(anio)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsMeta = response.data;
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        getMetasDisabled(){
            const anio = this.selectedAnioEjec.value;
            this.$vs.loading();
            this.$http.listarMetasInhabilitados(anio)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsMeta = response.data;
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        sincronizar(){
            const anio = this.selectedAnioEjec.value;
            this.$vs.loading();
            this.$http.sincronizar(anio)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.showMessageSuccess('Se actualizó de forma correcta.');
                    this.getMetasAll();
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        enabled(tr){
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirmación`,
                text: '¿Esta seguro de habilitar la meta ' + tr.meta + '?',
                acceptText: 'Si',
                cancelText: 'No',
                accept: this.habilitar
            });
            this.metaId = tr.id;
            this.numeroMeta = tr.meta;
        },

        habilitar(){
            this.$vs.loading();
            this.$http.habilitar(this.metaId)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.showMessageSuccess('Se habilitó de forma correcta.');
                    this.getMetasAll();
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        edit(tr){
            console.log(tr);
            this.$vs.dialog({
                type: 'alert',
                color: 'warning',
                title: `Aviso`,
                text: 'Módulo en desarrollo... Meta: ' + tr.meta,
                acceptText: 'Aceptar',
            });
        },

        disabled(tr){
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirmación`,
                text: '¿Esta seguro de inhabilitar la meta ' + tr.meta + '?',
                acceptText: 'Si',
                cancelText: 'No',
                accept: this.inhabilitar
            });
            this.metaId = tr.id;
            this.numeroMeta = tr.meta;
        },

        inhabilitar(){
            this.$vs.loading();
            this.$http.inhabilitar(this.metaId)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.showMessageSuccess('Se inhabilitó de forma correcta.');
                    this.getMetasAll();
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        

        getOrderStatusColor (status) {
            if (status) return 'success'
            return 'danger'
        },

        showMessageAlert(message){
            this.$vs.notify({
                title: 'Aviso',
                text: message,
                position:'top-center',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        },

        showMessageSuccess(message){
            this.$vs.notify({
                title: 'Información',
                text: message,
                position:'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
            });
        },

        showMessageError(status, message){
            if(status === 400 || status === 409){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 401){
                this.popupRiesgo = false;
                this.$store.dispatch("logout").then(() => {
                    this.$router.push('/login').catch(() => {})
                });
            }
            if(status === 403){
                this.popupPaciente = false;
                this.popupEliminar = false;
                this.$vs.notify({
                    title: 'ACCESO DENEGADO',
                    text: 'No tiene permisos para esta proceso.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            if(status === 404){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 417){
                this.$vs.notify({
                    title: 'ALERTA',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            if(status === 500){
                this.$vs.notify({
                    title: 'ERROR',
                    text: 'Ups!!!. Ocurrio un error. Vuelve a intentarlo.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle',
                    color: 'danger'
                });
            }
        },
    }
}
</script>
<style lang="scss">
#data-parametro-meta-view {
.vs-con-table {
    @media (max-width: 689px) {
        .vs-table--search {
            margin-left: 0;
            max-width: unset;
            width: 100%;

            .vs-table--search-input {
                width: 100%;
            }
        }
    }

    @media (max-width: 461px) {
        .items-per-page-handler {
            display: none;
        }
    }

    @media (max-width: 341px) {
        .data-list-btn-container {
            width: 100%;

            .dd-actions,
            .btn-add-new {
                width: 100%;
                margin-right: 0 !important;
            }
        }
    }

    .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 0.0rem;
        margin-right: 0.0rem;
        > span {
            display: flex;
            flex-grow: 1;
        }

        .vs-table--search{
            padding-top: 0;

            .vs-table--search-input {
                padding: 1.0rem 2.5rem;
                font-size: 1rem;

                &+i {
                    left: 1rem;
                }

                &:focus+i {
                    left: 1rem;
                }
            }
        }
    }

    .vs-table {
        font-size: 0.88rem;
        font-weight: 400;
        tr {
            box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
            td {
                padding: 10;
            }
            td.td-check {
               padding: 20px !important;
            }
        }
    }

    .vs-table--thead{
        th {
            padding: 10;
            background: #d9d8d8;
      
            &:first-child{
                border-top-left-radius: .3rem;
                border-bottom-left-radius: .3rem;
            }
            &:last-child{
                border-top-right-radius: .3rem;
                border-bottom-right-radius: .3rem;
            }
            .vs-table-text{
                text-transform: uppercase;
                font-weight: 600;
            }
        }
        th.td-check{
            padding: 0 15px !important;
        }
        tr{
            background: none;
            box-shadow: none;
        }
    }

    .vs-table--pagination {
        justify-content: center;
    }
  }
}

.vx-row-actions {
  display: flex;
  flex-wrap: nowrap;
  margin: 0 -1rem;

  & > .vx-col {
    padding: 0 1rem;
  }

  &.match-height>.vx-col {
    display: flex;
  }

  &.no-gutter {
    margin: 0;

    & > .vx-col {
      padding: 0;
    }
  }
}
</style>